var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[(_vm.isLoadingEnterprises)?_c('Loader'):_vm._e(),_c('div',{class:_vm.$style.description},[_c('h1',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.$t('ENTERPRISES')))])]),_c('v-row',{class:_vm.$style.test},[_c('EnterpriseSearch')],1),_c('v-row',{class:_vm.$style.enterprises},[_c('EnterpriseList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }